import { MutationHookOptions, useMutation } from "@apollo/react-hooks";
import updateAgreementDocument from "../graph-ql/updateAgreementDocument.graphql";

const useMutationUpdateAgreementDocument = ({
  onCompleted,
  onError,
}: MutationHookOptions) =>
  useMutation<{
    personKey: string;
    franAgreeDocKey: string;
    documentName: string;
    file: Buffer;
    type: string;
  }>(updateAgreementDocument, {
    onCompleted,
    onError,
  });

export default useMutationUpdateAgreementDocument;
